// extracted by mini-css-extract-plugin
export default {"container":"chatInput_container__zdqiH","containerDesktop":"chatInput_containerDesktop__wlva-"};